import moment from "moment"
import { callSP } from "setup/axios/AxiosCallSP"
export const getDataDays = async (file: any) => {
    const dataItem: any = file['Dias_semanas'][0]
    const getIdTable = await callSP('amd_get_contrato_servicio', [
        { text: 'id_sitio', value: `${dataItem.Cod_Sitio}` },
        { text: 'id_regimen', value: `${dataItem['Regimen Código']}` },
        { text: 'id_tipo_servicio', value: `${dataItem['Servicio Código']}` },
        { text: 'id_estructura_hijo', value: '0' }
    ])
    return getIdTable.data.result[0];
}
export const getServiceContract = async (file: any, item: any) => {
    const dataItem: any = file[item][0]
    const getIdTable = await callSP('amd_get_contrato_servicio', [
        { text: 'id_sitio', value: `${dataItem.Cod_Sitio}` },
        { text: 'id_regimen', value: `${dataItem['Regimen Código']}` },
        { text: 'id_tipo_servicio', value: `${dataItem['Servicio Código']}` },
        {
            text: 'id_estructura_hijo', value: (
                dataItem.estructura ? dataItem.estructura :
                    dataItem["Estructura código"] ? dataItem["Estructura código"] : '0'
            )
        }
    ])
    return getIdTable.data.result[0];
}
export const getContact = (dataItem: any) => {
    return dataItem.map((data: any) => {
        return {
            parameters: [
                {
                    text: 'tabla',
                    value: 'amd_contrato_servicio'
                },
                {
                    text: 'columnas',
                    value: 'id_sitio,id_tipo_servicio,id_regimen,costo_objetivo_mensual,ciclo_minuta,ciclo_plantilla,ciclos,fecha_creacion,id_tipo_plantilla,id_tipo_frecuencia'
                },
                {
                    text: 'valores',
                    value: `${data.id},${data['Servicio Código']},${data['Regimen Código']},${data.Costo_Objetivo},${data.Ciclos_Minuta},${data['Ciclo Plantilla']},${data['Ciclos']},${moment().format('DD-MM-YYYY')}, ${data['Tipo_Plantilla (Rotativa = 1, Fija = 2, No rotativa = 3)']}, ${data['Tipo_Frecuencia sodexo = 0, contractual = 1']}`
                }
            ]
        }
    })
}
export const insertStructure = async (file: any, item: any, dataItem: any) => {
    const result: any = await getServiceContract(file, item);
    return dataItem.map((item: any) => {
        return {
            sp: "amd_insertEstructuraContrato",
            parameters: [
                { text: 'id', value: "1" },
                { text: 'order', value: item.Orden },
                { text: 'id_contrato', value: result.ID.toString() },
                { text: 'id_servicio', value: item["Servicio Código"] },
                { text: 'id_estructura', value: item["Macro_Estructura código"] },
                { text: 'id_estilo_aliminatacion', value: "3" },
                { text: 'id_sellos', value: 2 },
                { text: 'id_intolerancia', value: item.INTOLERANCIA },
                { text: 'id_alergeno', value: item.ALERGENO },
                { text: 'id_categoria_dietetica', value: item["Categoria_Dietetica código"] },
                { text: 'estructura', value: item["Estructura nombre"] },
                { text: 'relacion', value: "0" },
                { text: 'diasBloqueados', value: item["BLOQUEADOS"] || "" },
                { text: 'tipo_plato', value: item["Tipo_Plato"] },
                { text: 'id_estructura_hijo', value: item["DESC"] || "" }
            ]
        }
    })
}
export const fixedStructure = async (file: any, item: any, dataItem: any) => {
    const result: any = await getServiceContract(file, item);
    return dataItem.map((item: any) => {
        return {
            parameters: [
                {
                    text: 'tabla',
                    value: 'amd_estructura_fija'
                },
                {
                    text: 'columnas',
                    value: 'id_sitio,id_contrato,id_grupo_estructura,replica'
                },
                {
                    text: 'valores',
                    value: `${item["Cod_Sitio"]},${result.ID},${item['Código estructura']},0`
                }
            ]
        }
    })
}
export const ingredientFrequency = async (file: any, item: any, dataItem: any) => {
    const result: any = await getServiceContract(file, item);
    return dataItem.map((item: any) => {
        return {
            sp: "amd_insertFrecuenciaContrato",
            parameters: [
                { text: 'id_contrato', value: result.ID.toString() },
                { text: 'id_estructura_contrato', value: result.ID_E.toString() },
                { text: 'cantidad_frecuencia', value: item.Frecuencia },
                { text: 'semana', value: item.Semanas },
                { text: 'comodin', value: "0" },
                { text: 'id_categoria_dietetica', value: item["id_cat_dietetica"] }
            ]
        }
    })
}
export const structureWeighting = async (dataItem: any) => {
    return dataItem.map((data: any) => {
        return {
            parameters: [
                {
                    text: 'tabla',
                    value: 'amd_ponderacion_estructura'
                },
                {
                    text: 'columnas',
                    value: 'id_estructura,id_sitio,ponderacion,fecha_creacion,usuario,regimen,servicio'
                },
                {
                    text: 'valores',
                    value: `${data["Cód. Gran Est."]},${data["Sitios (Ceco)"]},${data[" % "]},${new Date().toISOString().substring(0, 10)},1,${data["Cód. Regimen"]},${data["Cód. Servicio"]}}`
                }
            ]
        }
    })
}
export const fixedRecipe = async (file: any, item: any, dataItem: any) => {
    const result: any = await getServiceContract(file, item);
    return dataItem.map((item: any) => {
        return {
            sp: "amd_insertRecetaFija",
            parameters: [
                { text: 'id_estructura_contrato', value: result.ID_E.toString() },
                { text: 'id_contrato', value: result.ID.toString() },
                { text: 'id_receta', value: item.receta },
                { text: 'id_ingrediente_principal', value: item.Ingrediente_Principal },
                { text: 'dia_ciclo', value: item["dia num"] },
                { text: 'ciclo', value: item["Semana"] },
                { text: 'intercalado', value: "1" },
                { text: 'id_categoria_dietetica', value: item["Categoria_Dietetica"] },
            ]
        }
    })

}
export const weekDays = (dataItem: any, result: any) => {
    return dataItem.map((data: any) => {
        return {
            parameters: [
                {
                    text: 'tabla',
                    value: 'amd_dia_semana'
                },
                {
                    text: 'columnas',
                    value: 'id_contrato,dia,estado,q_comensales,n_dia'
                },
                {
                    text: 'valores',
                    value: `${result.ID}, ${(data.Comensales > 0) ? 0 : 1}, ${data.Estado}, ${data.Comensales}, ${data.Dia}`
                }
            ]
        }
    })
}
export const ponderationWeighting = (dataItem: any) => {
    return dataItem.map((data: any) => {
        return {
            parameters: [
                {
                    text: 'tabla',
                    value: 'amd_ponderacion_sitio'
                },
                {
                    text: 'columnas',
                    value: 'id_ingrediente,id_sitio,ponderacion,fecha_creacion,usuario,regimen,servicio'
                },
                {
                    text: 'valores',
                    value: `${data["Cód. Ingrediente principal"]},${data["Cód. Ceco"]}, ${data[" Ponderacion "]}, ${new Date().toISOString().substring(0, 10)}, 2,${data["Cód. Regimen"]},${data["Cód. Servicio"]}`
                }
            ]
        }
    })
}